// Реестр публичных SEO-лендингов: единственный источник правды о путях.
//
// Лёгкий модуль БЕЗ зависимостей от кита/контента — его синхронно импортирует
// App.tsx (решить, что текущий путь — лендинг, и отдать его полноэкранно вне
// app-shell), а сам кит с контентом грузится отдельным lazy-чанком.
//
// Этот же список рисует перелинковку в футере лендингов. При добавлении
// лендинга синхронизировать: public/sitemap.xml (из него пререндер берёт список
// страниц) и map $known_route в nginx.conf — см. docs/SEO.md, раздел
// «SEO-лендинги»; рассинхрон ловит landings.test.ts.
export const LANDING_ROUTES = [
    { path: "/ii-generator-pesen", label: "ИИ-генератор песен" },
    { path: "/generator-pesen", label: "Генератор песен онлайн" },
    { path: "/pesnya-na-den-rozhdeniya", label: "Песня на день рождения" },
    { path: "/pesnya-na-novyj-god", label: "Песня на Новый год" },
    { path: "/pesnya-na-svadbu", label: "Песня на свадьбу" },
    { path: "/pesnya-na-yubilej", label: "Песня на юбилей" },
    { path: "/pesnya-dlya-muzha", label: "Песня для мужа" },
    { path: "/pesnya-dlya-papy", label: "Песня для папы" },
    { path: "/pesnya-dlya-lyubimoj", label: "Песня для любимой" },
    { path: "/pesnya-dlya-podrugi", label: "Песня для подруги" },
    { path: "/ii-kaver-generator", label: "AI-кавер генератор" },
    { path: "/generator-teksta-pesni", label: "Генератор текста песни" },
];
const LANDING_PATHS = new Set(LANDING_ROUTES.map((r) => r.path));
/** Текущий pathname — один из SEO-лендингов (хвостовой слеш допускаем). */
export const isSeoLandingPath = (pathname) => LANDING_PATHS.has(pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname);
